const generateRandomNumber = () => Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
export { generateRandomNumber };
